var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subnav" },
    [
      _c(
        "v-expansion-panel",
        {
          model: {
            value: _vm.dtExpandActive,
            callback: function($$v) {
              _vm.dtExpandActive = $$v
            },
            expression: "dtExpandActive"
          }
        },
        _vm._l(_vm.dtWidget, function(menu, i) {
          return _c(
            "v-expansion-panel-content",
            {
              key: i,
              staticClass: "subnav__panel",
              class: {
                "subnav__item--active": i === _vm.dtExpandActive,
                subnav__item: i !== _vm.dtExpandActive
              },
              style: [
                i === _vm.dtExpandActive
                  ? { "background-color": "#f92ac2 !important" }
                  : { "background-color": "transparent !important" }
              ],
              attrs: { "expand-icon": null }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "white--text none-underline--link",
                  attrs: { slot: "header", to: _vm.getPath(menu.key) },
                  slot: "header"
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.blockSidebar[menu.key])) +
                        " " +
                        _vm._s(_vm.getTotal(menu.totalKey))
                    )
                  ])
                ]
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a36cdbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a36cdbc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-apartment-sidebar/template.html
// module id = null
// module chunks = 